"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var app = {
  state: {
    sidebar: {
      opened: window.screen.width < 1600 ? false : !+_jsCookie["default"].get('sidebarStatus'),
      dark: true // icon: 'sk-icon-cloud'
      // label: '云办公管理控制台'

    },
    language: _jsCookie["default"].get('language') || 'zh',
    module: null,
    permission_tabs: null,
    isLowResolution: false,
    htmlFontBaseSize: '12'
  },
  mutations: {
    TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
      if (state.sidebar.opened) {
        _jsCookie["default"].set('sidebarStatus', 1);
      } else {
        _jsCookie["default"].set('sidebarStatus', 0);
      }

      state.sidebar.opened = !state.sidebar.opened;
    },
    SET_LANGUAGE: function SET_LANGUAGE(state, language) {
      state.language = language;

      _jsCookie["default"].set('language', language);
    },
    SET_MODULE: function SET_MODULE(state, module) {
      state.module = module;
    },
    SET_LOWRESOLUTION: function SET_LOWRESOLUTION(state, isLowResolution) {
      state.isLowResolution = isLowResolution;
    },
    SET_HTML_FONT_BASE_SIZE: function SET_HTML_FONT_BASE_SIZE(state, htmlFontBaseSize) {
      state.htmlFontBaseSize = htmlFontBaseSize;
    }
  },
  actions: {
    toggleSideBar: function toggleSideBar(_ref) {
      var commit = _ref.commit;
      commit('TOGGLE_SIDEBAR');
    },
    setLanguage: function setLanguage(_ref2, language) {
      var commit = _ref2.commit;
      commit('SET_LANGUAGE', language);
    },
    changeView: function changeView(_ref3, module) {
      var commit = _ref3.commit;
      commit('SET_MODULE', module);
    },
    setLowResolution: function setLowResolution(_ref4, isLowResolution) {
      var commit = _ref4.commit;
      commit('SET_LOWRESOLUTION', isLowResolution);
    },
    setHtmlFontBaseSize: function setHtmlFontBaseSize(_ref5, htmlFontBaseSize) {
      var commit = _ref5.commit;
      commit('SET_HTML_FONT_BASE_SIZE', htmlFontBaseSize);
    }
  }
};
var _default = app;
exports["default"] = _default;